import { useEffect } from "react";
import { useAuth } from "../../App";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { GLOBAL_STYLES } from "../../tokens";

/**
 * Common chrome for marketing pages — Navbar + Footer + global styles
 * + `document.title` update + scroll-to-top on mount.
 *
 * Keeps every marketing page visually and semantically consistent
 * while letting the page body focus on content.
 */
export default function MarketingShell({ title, description, children }) {
  const { user } = useAuth();

  useEffect(() => {
    if (title) document.title = `${title} · Fayriza`;
    else document.title = "Fayriza";
  }, [title]);

  useEffect(() => {
    if (typeof description === "string" && description.length > 0) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [description]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <>
      <style>{GLOBAL_STYLES}</style>
      <main>{children}</main>
      <Footer />
    </>
  );
}
